import sImg1 from "../images/services/Website_result.webp";
import sImg2 from "../images/services/Mobiel_App_result.webp";
import sImg3 from "../images/services/E-Commerce_result.webp";
import sImg4 from "../images/services/Custom_Software_result.webp";
import sImg5 from "../images/services/UIUXDesign_result.webp";
import sImg6 from "../images/services/Graphic_Designing_result.webp";
import sImg7 from "../images/services/Video_Editing_result.webp";
import sImg8 from "../images/services/SEO_result.webp";
import sImg9 from "../images/services/SMO_result.webp";
import react from "../images/icon_image/1_result.webp";
import express from "../images/icon_image/8_result.webp";
import node from "../images/icon_image/7_result.webp";
import mongo from "../images/icon_image/10_result.webp";
import post from "../images/icon_image/13_result.webp";
import next from "../images/icon_image/3_result.webp";
import ts from "../images/icon_image/2_result.webp";
import sass from "../images/icon_image/5_result.webp";
import three from "../images/icon_image/6_result.webp";
import socket from "../images/icon_image/9_result.webp";
import firebase from "../images/icon_image/12_result.webp";
import redis from "../images/icon_image/14_result.webp";
import wordpress from "../images/icon_image/17_result.webp";
import apple from "../images/icon_image/15_result.webp";
import android from "../images/icon_image/16_result.webp";
import shopify from "../images/icon_image/18_result.webp";
import Photoshop from "../images/icon_image/Adobe_Photoshop_result.webp";
import premierpro from "../images/icon_image/Adobe_Premiere_Pro_CC_result.webp";
import canva from "../images/icon_image/canva.webp";
import figma from "../images/icon_image/figma.webp";
import after from "../images/icon_image/Adobe_After_Effect_result.webp";
import blender from "../images/icon_image/blender_result.webp";
import xd from "../images/icon_image/Adobe_XD_result.webp";
import illus from "../images/icon_image/Adobe_Illustrator_result.webp";

const Services = [
  {
    Id: "1",
    sImg: sImg1,
    title: "Best Web Development Company In Alwar",
    slug: "web-development-services",
    thumb1: "Responsive",
    TechStack: [
      react,
      node,
      express,
      mongo,
      post,
      next,
      ts,
      sass,
      three,
      socket,
      firebase,
      redis,
    ],
    thumb2: "High-Performance",
    bold:`RashTech Info Provides the Best Web Development Services in Alwar`,
    service:'We offer advanced and scalable web solutions that are fast, secure, and SEO-friendly. RashTech Info, the Top Web Development Company in Alwar, develops responsive websites with advanced features to create a better user experience and increase online presence worldwide.',
    heading: 'Web Development',
    footer: 'Web Development',
    col: "col-lg-6",
    description:`Do you seek a website that shows your business, engages your customers, and drives results? RashTech Info offers Best Web Development Services in Alwar, India, equipping startups, SMEs, and businesses with amazing websites and powerful web applications. Since 2018, we have been offering the latest web solutions to clients across India, USA, UK, Canada, UAE, and Australia.`,
    description2:`From hygienic corporate websites to intricate e-commerce websites, our web development skill guarantees high functionality, mobility compatibility, and flawless performance. With clear-cut processes and budget-friendly packages, we have emerged as the most trusted Web Development Company in Alwar, supporting 200+ businesses in making a strong digital presence and measurable growth.`
  },
  {
    Id: "2",
    sImg: sImg2,
    heading: 'App Development',
    title: "Best App Development Company In Alwar",
    footer:'App Development',
    slug: "app-development-services",
    thumb1: "iOS & Android",
    TechStack: [react, apple, android],
    thumb2: "Cross-Platform",
    bold: "RashTech Info Provides the Best App Development Services in Alwar",
    service:'RashTech Info provides modern and secure mobile applications customised for companies. Being the Best App Development Company in Alwar, we develop Android, iOS, and cross-platform apps with seamless performance, sleek design, and scalability to target local and global consumers efficiently.',
    col: "col-lg-6",
    description: `Your company requires more than a website — it requires a strong mobile app that gets you in touch with customers on the move. RashTech Info, the Best App Development Company in Alwar, offers advanced mobile app development solutions that are tailored to bring high performance, easy-to-use experiences, and sustainable growth.`,
    description2: `Since 2018, we have been working with clients not just in Alwar, Rajasthan, and India but also internationally in the USA, UK, UAE, Canada, and Australia. We build custom Android apps, iOS applications, as well as cross-platform apps for you, as per your business objectives. Our expert developers design an app according to your specific needs.`,
  },
  {
    Id: "3",
    sImg: sImg3,
    title: "Best E-commerce Company In Alwar",
    slug: "e-commerce-solutions-services",
    thumb1: "Storefront",
    heading: 'E-commerce',
    footer: 'E-commerce Solution',
    TechStack: [shopify, wordpress],
    thumb2: "Integrations",
    bold:`RashTech Info Provides the Best E-commerce Solutions in Alwar`,
    service: "Construct robust online shops with RashTech Info, the Best Alwar E-commerce Development Company. We design secure, scalable, and easy-to-use e-commerce sites with payment integration and SEO-friendly architecture to enhance online revenues around the world.",
    col: "col-lg-6 col-xl-4 ",
    description:`The future of business is online, and a robust e-commerce presence is no longer a choice. RashTech Info, the Best E-commerce Development Company in Alwar, assists businesses of all sizes in building effective, secure, and scalable online stores. Our e-commerce solutions are made to bring customers in, grow sales, and deliver seamless shopping experiences.`,
    description2:`Ever since 2018, we have been providing top-notch E-commerce Solutions in Alwar, throughout India, as well as overseas in places such as the USA, UK, UAE, Canada, and Australia. If you wish to start a new online shopping site or give a boost to your current site, our highly experienced developers design personalized solutions that will match your business and market.`
  },
  {
    Id: "4",
    sImg: sImg4,
    title: " Best Custom Development Company In Alwar",
    slug: "custom-software-services",
    footer: 'Custom Development',
    heading:'Custom Development',
    TechStack: [
      react,
      node,
      express,
      mongo,
      next,
      ts,
      sass,
      three,
      socket,
      firebase,
      redis,
      post,
    ],
    thumb1: "Tailored",
    thumb2: "Scalable",
    bold:`RashTech Info Provides the Best Custom Software Solutions in Alwar`,
    service:"RashTech Info, the Best Alwar Custom Software Development Company, builds customized solutions that automate business processes, boost efficiency, and facilitate expansion. Our scalable and secure software evolves with your company's needs locally and globally.",
    col: "col-lg-6 col-xl-4",
    description:`Each business is different, and so are its requirements. Off-the-shelf software cannot always satisfy your individual requirements. RashTech Info, top Custom Software Development Company in Alwar, offers scalable, secure, and customized software solutions tailored to fulfill your precise business requirements`,
    description2:`Since 2018, we have been providing expert Custom Software Development Services in Alwar, India, and worldwide to USA, UK, UAE, Canadian, and Australian customers. If you're looking for enterprise-level applications, business automation software, or specialized domain software, our professional developers design and deploy software that drives your business forward.`
  },
  {
    Id: "5",
    sImg: sImg5,
    title: "Best UI/UX Design Company In Alwar",
    heading:'UI/UX Design',
    footer:'UI/UX Design',
    slug: "ui-ux-development-services",
    thumb1: "Design Systems",
    TechStack: [figma, canva, xd],
    thumb2: "Prototyping",
    bold:`RashTech Info Provides the Best UI/UX Development Services in Alwar`,
    service:'We design user-centered and interactive designs that maximize digital experiences. RashTech Info, one of the top UI/UX Design Companies in Alwar, design attractive interfaces with smooth navigation to enhance customer satisfaction and brand loyalty across sectors.',
    col: "col-lg-12 col-xl-4",
    style: 'adjust',
    description:`Initial impressions count. A good-looking interface can determine whether a consumer remains on your site or bails out in a matter of seconds. RashTech Info, the Top UI/UX Development company in Alwar, is an expert in designing user interfaces and experiences that are beautiful, intuitive, and designed to convert visitors into returning patrons.`,
    description2:`Since 2018, we have been providing professional UI/UX Development Services in Alwar, throughout India, and internationally in the USA, UK, UAE, Canada, and Australia. You need fresh corporate software experience, a mobile application interface, or a website design. Performance, usability, and aesthetics are the top priorities for our skilled designers.`
  },
  {
    Id: "6",
    sImg: sImg6,
    title: "Best Graphic Design Company In Alwar",
    slug: "graphic-design-services",
    heading:'Graphic Design',
    footer:'Graphic Design',
    TechStack: [figma, canva, illus, Photoshop],
    thumb1: "Branding",
    thumb2: "Creatives",
    bold:`RashTech Info Provides the Best Graphic Design Services in Alwar`,
    service:"RashTech Info, Alwar's top graphic design agency, produces innovative visuals, branding materials, and digital assets that speak of your business identity. Our expert design services make brands stand out and resonate with audiences across India and abroad.",
    col: "col-lg-3",
    description: `Design is the first thing that your customers notice in this age of digital technologies. A strong visual identity not only draws attention to your company but also successfully conveys its message and fosters long-lasting trust. To assist companies in becoming unique in densely populated markets, RashTech Info, Alwar's best graphic design company, offers innovative and expert graphic design services. Our goal is to develop images that motivate, inspire, and transform audiences into loyal customers.
We have been offering Graphic Design Services in Alwar, India, and globally in the USA, UK, UAE, Canada, and Australia since 2018. From logo and business cards to branding kits and social media posts, and internet marketing graphics, we customize every design to be effective, consistent, and on track to fulfill your business objectives. Whether you are a start-up company or a company, our design team provides personalized graphic design in Alwar to build your brand image and sustain growth.
`,
description2:`We have been offering Graphic Design Services in Alwar, India, and globally in the USA, UK, UAE, Canada, and Australia since 2018. From logo and business cards to branding kits and social media posts, and internet marketing graphics, we customize every design to be effective, consistent, and on track to fulfill your business objectives. Whether you are a start-up company or a company, our design team provides personalized graphic design in Alwar to build your brand image and sustain growth.
`
  },
  {
    Id: "7",
    sImg: sImg7,
    title: "Best Video Editing Company In Alwar",
    slug: "video-editing-services",
    heading:'Video Editing ',
    footer:' Video Editing',
    TechStack: [premierpro, after],
    thumb1: "Motion",
    thumb2: "Storytelling",
    bold:`RashTech Info Offers the Best Video Editing Services in Alwar`,
    service:"RashTech Info, the Top Video Editing Agency in Alwar, offers professional video services to businesses and individuals alike. From promotional to corporate edits, our innovative editing creates great brand storytelling and enables businesses to connect with their audience worldwide.",
    col: "col-lg-3",
    description: `The most effective way to interact with your audience and convey your business message is through video. A well created video improves conversions, builds trust, and raises engagement. RashTech Info, the Best Video Editing Company in Alwar, provides superior video editing services that bring life to your concepts.
We have been offering Video Editing Services in Alwar, India, and globally since 2018 and have dealt with USA, UK, UAE, Canada, and Australian business owners and content creators. Whether you require promotional commercials or corporate videos, social media content, or product descriptions, our trained editors bring shine, effects, and contextualization to each video.
`,
description2:`We have been offering Video Editing Services in Alwar, India, and globally since 2018 and have dealt with USA, UK, UAE, Canada, and Australian business owners and content creators. Whether you require promotional commercials or corporate videos, social media content, or product descriptions, our trained editors bring shine, effects, and contextualization to each video.
`
  },
  {
    Id: "8",
    sImg: sImg8,
    title: "Best SEO Company In Alwar",
    slug: "seo-services",
    heading:'SEO',
    footer: 'SEO',
    thumb1: "Technical",
    thumb2: "Content",
    bold: "RashTech Info Provides the Best SEO Services in Alwar",
    service:'Enhance your online visibility with RashTech Info, the Best SEO Company in Alwar. Our performance-based SEO practices boost organic traffic, keyword ranks, and higher conversions. We provide customized solutions to grow your business locally and internationally.',
    col: "col-lg-3",
    description: `Do you desire your site to appear first on Google's search results page? RashTech Info offers the Best SEO Services in Alwar, India, and helps your business develop online presence, bring greater visibility, and attain maximum ROI. Since 2018, apart from global marketplaces like the USA, UK, Canada, UAE, and Australia, we have been delivering effective SEO services in key cities like Alwar, Jaipur, Delhi, and Gurugram.
`,
    description2: `The secret to attracting new clients and increasing sales is having a strong web presence. You risk losing out on fantastic prospects for rivals if you don't use good SEO. At RashTech Info, we strive to put yourwebsite on Google's first page using proven keyword strategies, technical SEO, and link building. We are the Best SEO Company in Alwar, preferred by 200+ businesses since 2018. We offer transparent process and professional SEO services, which give measurable growth for local and global clients.`,
  },
  {
    Id: "9",
    sImg: sImg9,
    title: "Best SMO Company In Alwar",
    slug: "smo-services",
    heading:'SMO',
    footer: 'SMO',
    thumb1: "Growth",
    thumb2: "Engagement",
    bold: `RashTech Info Provides Top-Class SMO Services in Alwar`,
    service:"Enhance your online presence with RashTech Info, Alwar's Best SMO Company. Our social media optimization services enhance brand visibility, generate more engagement, and bring in new customers across platforms, enabling business growth in India and globally.",
    col: "col-lg-3",
    description: `Social media is arguably the most effective tool that businesses have at their disposal to reach their audience in the current digital-first era. In addition to increasing visibility, effective social media optimisation builds interaction, builds trust, and increases conversions. RashTech Info, the Best SMO Company in Alwar, offers expert social media optimization services that aid help brand's development on platforms such as Facebook, Instagram, Twitter, LinkedIn, and YouTube.
`,
    description2: `Ever since 2018, we have been providing SMO Services in Alwar, India, and worldwide, supporting startups, small enterprises, and businesses in increasing their digital footprint. Our tactics aim at developing rich content, optimizing profiles, and activating target campaigns generating measurable results.
`,
  },
];

export default Services;
